import { Maybe, StageStatus, TaskDefinitionStage, TaskStage, TaskState, TaskStatus } from "fond/types";

const stageStateToStageStatus = (state: TaskState): StageStatus => {
  if (state === "IN_PROGRESS") {
    return "InProgress";
  }
  if (state === "PENDING") {
    return "Idle";
  }
  if (state === "COMPLETE") {
    return "Success";
  }
  if (state === "ERROR") {
    return "Error";
  }

  throw new Error(`Unrecognized stage state ${state}.`);
};

const taskDefinitionStageToTaskStage = (taskDefinitionStage: TaskDefinitionStage): TaskStage => {
  const { Key: key, State: stageState } = taskDefinitionStage;
  return { key, status: stageStateToStageStatus(stageState) };
};

/**
 * Return the stages of a task.
 */
export const getTaskStages = (taskDefinition: Maybe<TaskStatus["Definition"]>): TaskStage[] | null =>
  taskDefinition?.Stages.map(taskDefinitionStageToTaskStage) ?? null;

/**
 * Return the current in-progress stage of a task, or undefined if no stage is in progress.
 */
export const getTaskInProgressStage = (task: Maybe<TaskStatus>): TaskStage | undefined => {
  if (!task || ["PENDING", "COMPLETE", "ERROR"].includes(task.State)) return undefined;

  const taskDefinitionStage = task?.Definition?.Stages?.find((stage) => stage.State === "IN_PROGRESS");
  if (!taskDefinitionStage) return undefined;

  return taskDefinitionStageToTaskStage(taskDefinitionStage);
};
